<template>
  <div class="marketing-automation-form-panel-entry">
    <app-form @submit="setStep">

      <div class="marketing-automation-form-panel-entry-body"
           :class="{ 'marketing-automation-form-panel-entry-body_opened': isCriterionOpened }">
        <marketing-automation-form-panel-entry-section-criterion v-model="form.criterion"
                                                                 @opened="onCriterionOpened"
                                                                 @hidden="onCriterionHidden"
                                                                 @input="unsetIsCriterionOpened" />

        <marketing-automation-form-panel-entry-section-campaign v-if="startsByCampaign"
                                                                v-model="form.campaignsData" />

        <marketing-automation-form-panel-entry-section-local v-if="form.criterion.stepType && doesntStartByExternalDatabase"
                                                             v-model="form.localIds"
                                                             :automationId="automationId"
                                                             :step="step" />

        <marketing-automation-form-panel-entry-section-filter v-if="form.criterion.stepType"
                                                              v-model="form.filters"
                                                              :isNotExternalDatabase="doesntStartByExternalDatabase"
                                                              @change="setGenderFilters"
                                                              @select="setExtraFieldsFilter"
                                                              @setUseTerms="setUseTerms"
                                                              @input="setAgeFilters" />

        <marketing-automation-form-panel-section-repeat v-if="form.criterion.stepType"
                                                        v-model="form.repeat"
                                                        :type="form.criterion.stepType" />
      </div>

      <marketing-automation-form-panel-section>
        <button class="marketing-automation-form-panel-entry-section-action btn btn-round btn-primary"
                type="submit">{{$t('message.automation.message.setCriteria')}}</button>
      </marketing-automation-form-panel-section>
    </app-form>
  </div>
</template>

<script>
import MarketingAutomationFormPanelSection from "@components/modules/marketing/automation/form/steps/panel/section/MarketingAutomationFormPanelSection.vue";
import AppForm from "@components/form/Form.vue";
import MarketingAutomationFormPanelSectionRepeat from "@components/modules/marketing/automation/form/steps/panel/section/repeat/MarketingAutomationFormPanelSectionRepeat.vue";
import MarketingAutomationFormPanelEntrySectionCriterion from "@components/modules/marketing/automation/form/steps/panel/entry/section/criterion/MarketingAutomationFormPanelEntrySectionCriterion.vue";
import MarketingAutomationFormPanelEntrySectionLocal from "@components/modules/marketing/automation/form/steps/panel/entry/section/local/MarketingAutomationFormPanelEntrySectionLocal.vue";
import MarketingAutomationFormPanelEntrySectionFilter from "@components/modules/marketing/automation/form/steps/panel/entry/section/filter/MarketingAutomationFormPanelEntrySectionFilter";
import MarketingAutomationFormPanelEntrySectionCampaign from "@components/modules/marketing/automation/form/steps/panel/entry/section/campaign/MarketingAutomationFormPanelEntrySectionCampaign.vue";

export default {
  components: {
    MarketingAutomationFormPanelEntrySectionFilter,
    MarketingAutomationFormPanelSectionRepeat,
    AppForm,
    MarketingAutomationFormPanelEntrySectionCriterion,
    MarketingAutomationFormPanelEntrySectionLocal,
    MarketingAutomationFormPanelSection,
    MarketingAutomationFormPanelEntrySectionCampaign,
  },

  props: {
    step: {
      type: Object,
    },
    type: {
      type: String,
    },
    automationId: {
      type: String,
    },
  },

  computed: {
    startsByCampaign() {
      return this.form.criterion.stepType === "START_BY_CAMPAIGN";
    },
    doesntStartByExternalDatabase() {
      return this.form.criterion.stepType !== "START_BY_EXTERNAL_DATABASE";
    },
  },

  created() {
    if (this.step) {
      this.setInitialData();
    }
  },

  data() {
    return {
      form: {
        repeat: {
          periodToRepeat: undefined,
          isRepeat: false,
        },
        criterion: {
          stepType: undefined,
          daysWithoutAccess: undefined,
          accessCounter: undefined,
          daysBeforeBirthdate: undefined,
        },
        localIds: [],
        filters: {
          initialAge: 0,
          finalAge: 100,
          genderFilter: [],
          extraFields: "{}",
          useTerms: [],
        },
        campaignsData: {
          campaigns: [],
          interactions: [],
          options: [],
          npsValues: [],
        },
      },
      isCriterionOpened: false,
    };
  },

  methods: {
    onCriterionOpened() {
      this.isCriterionOpened = true;
      this.emitOpened();
    },
    onCriterionHidden() {
      this.unsetIsCriterionOpened();
      this.emitHidden();
    },
    unsetIsCriterionOpened() {
      this.isCriterionOpened = false;
    },
    emitOpened() {
      this.$emit("opened");
    },
    emitHidden() {
      this.$emit("hidden");
    },
    setInitialData() {
      this.form.repeat = {
        periodToRepeat: this.step.properties.periodToRepeat,
        isRepeat: this.step.properties.isRepeat,
      };

      this.form.criterion = {
        stepType: this.step.stepType,
        daysWithoutAccess: this.step.properties.daysWithoutAccess,
        accessCounter: this.step.properties.accessCounter,
        daysBeforeBirthdate: this.step.properties.daysBeforeBirthdate,
      };

      this.form.localIds = this.step.locals || [];

      this.form.filters = {
        initialAge: this.step.initialAge ? this.step.initialAge : 0,
        finalAge: this.step.finalAge ? this.step.finalAge : 100,
        genderFilter: this.step.genderFilter || [],
        extraFields:
          this.step.extraFields === null ? "{}" : this.step.extraFields,
        useTerms: this.step.useTerms || [],
      };

      this.form.campaignsData = {
        campaigns: this.step.properties.campaigns || [],
        interactions: this.step.properties.interactions || [],
        options: this.step.properties.options || [],
        npsValues: this.step.properties.npsValues || [],
      };
    },
    async setStep() {
      if (this.step) {
        return this.editStep();
      } else {
        return this.addStep();
      }
    },
    async addStep() {
      const properites = {
        ...this.form.repeat,
        daysWithoutAccess: this.form.criterion.daysWithoutAccess,
        accessCounter: this.form.criterion.accessCounter,
        daysBeforeBirthdate: this.form.criterion.daysBeforeBirthdate,
        campaigns: this.form.campaignsData.campaigns,
        interactions: this.form.campaignsData.interactions,
        options: this.form.campaignsData.options,
        npsValues: this.form.campaignsData.npsValues,
      };

      const steps = await this.$api.marketing.automation.flow.addStep({
        automationId: this.automationId,
        stepType: this.form.criterion.stepType,
        locals: this.form.localIds,
        properties: JSON.stringify(properites),
        initialAge: this.form.filters.initialAge,
        finalAge: this.form.filters.finalAge,
        genderFilter: this.form.filters.genderFilter,
        extraFields:
          this.form.filters.extraFields === "{}"
            ? null
            : this.form.filters.extraFields,
        useTerms: this.form.filters.useTerms,
      });

      this.$emit("submit", steps);

      return steps;
    },
    async editStep() {
      const properites = {
        ...this.form.repeat,
        daysWithoutAccess: this.form.criterion.daysWithoutAccess,
        accessCounter: this.form.criterion.accessCounter,
        daysBeforeBirthdate: this.form.criterion.daysBeforeBirthdate,
        campaigns: this.form.campaignsData.campaigns,
        interactions: this.form.campaignsData.interactions,
        options: this.form.campaignsData.options,
        npsValues: this.form.campaignsData.npsValues,
      };

      const steps = await this.$api.marketing.automation.flow.editStep({
        stepId: this.step.id,
        automationId: this.automationId,
        stepType: this.form.criterion.stepType,
        locals: this.form.localIds,
        properties: JSON.stringify(properites),
        initialAge: this.form.filters.initialAge,
        finalAge: this.form.filters.finalAge,
        genderFilter: this.form.filters.genderFilter,
        extraFields:
          this.form.filters.extraFields === "{}"
            ? null
            : this.form.filters.extraFields,
        useTerms: this.form.filters.useTerms,
      });

      this.$emit("submit", steps);

      return steps;
    },
    setAgeFilters(value) {
      this.form.filters.initialAge = value.initialAge;
      this.form.filters.finalAge = value.finalAge;
    },
    setGenderFilters(value) {
      if (this.step) {
        if (this.step.genderFilter) {
          this.form.filters.genderFilter = value.genderFilter.filter(
            (item) => !this.step.genderFilter.includes(item)
          );
        }
        this.form.filters.genderFilter = value.genderFilter;
      } else {
        this.form.filters.genderFilter = value.genderFilter;
      }
    },
    setExtraFieldsFilter(value) {
      if (value.length === 0) {
        this.form.filters.extraFields = null;
        return;
      }
      const extraFieldFilters = {};
      value.extraFields.map((item) => {
        extraFieldFilters[item.name] = item.value;
      });
      this.form.filters.extraFields = JSON.stringify(extraFieldFilters);
    },
    setUseTerms(value) {
      this.form.filters.useTerms = value.useTerms;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.marketing-automation-form-panel-entry {
  .marketing-automation-form-panel-entry-body {
    max-height: calc(100vh - 200px);

    overflow: scroll;
    border-bottom: 2px solid $grey-1;

    &.marketing-automation-form-panel-entry-body_opened {
      overflow: visible;
    }
  }

  .marketing-automation-form-panel-entry-section-action {
    margin: 0 auto;
    display: block;
  }
}
</style>
